export function formatRupiah(value) {
  if (!value && value !== 0) return "";

  const formatted = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(value);

  return `${formatted},-`;
}
